import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/array';
import __var_2__ from '@stdlib/assert';
import __var_3__ from '@stdlib/bench';
import __var_4__ from '@stdlib/blas';
import __var_5__ from '@stdlib/buffer';
import __var_6__ from '@stdlib/complex';
import __var_7__ from '@stdlib/constants';
import __var_8__ from '@stdlib/crypto';
import __var_9__ from '@stdlib/datasets';
import __var_10__ from '@stdlib/error';
import __var_11__ from '@stdlib/fastmath';
import __var_12__ from '@stdlib/fs';
import __var_13__ from '@stdlib/iter';
import __var_14__ from '@stdlib/math';
import __var_15__ from '@stdlib/ml';
import __var_16__ from '@stdlib/ndarray';
import __var_17__ from '@stdlib/net';
import __var_18__ from '@stdlib/nlp';
import __var_19__ from '@stdlib/number';
import __var_20__ from '@stdlib/os';
import __var_21__ from '@stdlib/plot';
import __var_22__ from '@stdlib/process';
import __var_23__ from '@stdlib/proxy';
import __var_24__ from '@stdlib/random';
import __var_25__ from '@stdlib/regexp';
import __var_26__ from '@stdlib/simulate';
import __var_27__ from '@stdlib/stats';
import __var_28__ from '@stdlib/streams';
import __var_29__ from '@stdlib/strided';
import __var_30__ from '@stdlib/string';
import __var_31__ from '@stdlib/symbol';
import __var_32__ from '@stdlib/time';
import __var_33__ from '@stdlib/utils';
'use strict';

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace. 
*
* @namespace stdlib
*/
var stdlib = {};

/**
* @name array
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/array}
*/
setReadOnly( stdlib, 'array', __var_1__);

/**
* @name assert
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/assert}
*/
setReadOnly( stdlib, 'assert', __var_2__);

/**
* @name bench
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/bench}
*/
setReadOnly( stdlib, 'bench', __var_3__);

/**
* @name blas
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/blas}
*/
setReadOnly( stdlib, 'blas', __var_4__);

/**
* @name buffer
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/buffer}
*/
setReadOnly( stdlib, 'buffer', __var_5__);

/**
* @name complex
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/complex}
*/
setReadOnly( stdlib, 'complex', __var_6__);

/**
* @name constants
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/constants}
*/
setReadOnly( stdlib, 'constants', __var_7__);

/**
* @name crypto
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/crypto}
*/
setReadOnly( stdlib, 'crypto', __var_8__);

/**
* @name datasets
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/datasets}
*/
setReadOnly( stdlib, 'datasets', __var_9__);

/**
* @name error
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/error}
*/
setReadOnly( stdlib, 'error', __var_10__);

/**
* @name fastmath
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/fastmath}
*/
setReadOnly( stdlib, 'fastmath', __var_11__);

/**
* @name fs
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/fs}
*/
setReadOnly( stdlib, 'fs', __var_12__);

/**
* @name iter
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/iter}
*/
setReadOnly( stdlib, 'iter', __var_13__);

/**
* @name math
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/math}
*/
setReadOnly( stdlib, 'math', __var_14__);

/**
* @name ml
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/ml}
*/
setReadOnly( stdlib, 'ml', __var_15__);

/**
* @name ndarray
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/ndarray}
*/
setReadOnly( stdlib, 'ndarray', __var_16__);

/**
* @name net
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/net}
*/
setReadOnly( stdlib, 'net', __var_17__);

/**
* @name nlp
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/nlp}
*/
setReadOnly( stdlib, 'nlp', __var_18__);

/**
* @name number
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/number}
*/
setReadOnly( stdlib, 'number', __var_19__);

/**
* @name os
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/os}
*/
setReadOnly( stdlib, 'os', __var_20__);

/**
* @name plot
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/plot}
*/
setReadOnly( stdlib, 'plot', __var_21__);

/**
* @name process
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/process}
*/
setReadOnly( stdlib, 'process', __var_22__);

/**
* @name proxy
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/proxy}
*/
setReadOnly( stdlib, 'proxy', __var_23__);

/**
* @name random
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/random}
*/
setReadOnly( stdlib, 'random', __var_24__);

/**
* @name regexp
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/regexp}
*/
setReadOnly( stdlib, 'regexp', __var_25__);

/**
* @name simulate
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/simulate}
*/
setReadOnly( stdlib, 'simulate', __var_26__);

/**
* @name stats
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/stats}
*/
setReadOnly( stdlib, 'stats', __var_27__);

/**
* @name streams
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/streams}
*/
setReadOnly( stdlib, 'streams', __var_28__);

/**
* @name strided
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/strided}
*/
setReadOnly( stdlib, 'strided', __var_29__);

/**
* @name string
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/string}
*/
setReadOnly( stdlib, 'string', __var_30__);

/**
* @name symbol
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/symbol}
*/
setReadOnly( stdlib, 'symbol', __var_31__);

/**
* @name time
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/time}
*/
setReadOnly( stdlib, 'time', __var_32__);

/**
* @name utils
* @memberof stdlib
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/utils}
*/
setReadOnly( stdlib, 'utils', __var_33__);


// EXPORTS //
export default stdlib;